import $ from 'jquery';
import 'jquery-touchswipe';
import 'jquery.easing';

import 'lib/bootstrap';
import 'lib/storage';
import 'lib/template';
import 'lib/graphql';
import 'lib/auth';
import 'lib/ajax';
import 'lib/query';
import 'lib/websockets';
import 'lib/notifications';
import 'lib/logrocket';
import 'lib/modal';
import 'lib/toastr';
import 'lib/throttle';
import 'lib/datefns';
import 'lib/form';
import 'lib/analytics';
import 'lib/tawk';
import 'lib/clipboard';
import 'lib/global';

const W = window;
const UI = {};
let waitForAuth = true;

W.jQuery = $;

window.addEventListener('error', evt => {
  console.log(evt);
});

$.fn.swipe.defaults.excludedElements = '.modal, .select2-container, .iti--container, [data-sortable]';

$.fn.slideIn = function (params) {
  const $obj = $(this);

  return $obj.animate(
    {
      opacity: 'show',
    },
    {
      duration: params.duration,
      easing: params.easing,
      complete: params.complete,
      step: function (now) {
        $obj.css('transform', 'translateX(' + (1 - now) * 110 + '%)');
      },
    },
  );
};

$.fn.slideOut = function (params) {
  const $obj = $(this);

  return $obj.animate(
    {
      opacity: 'hide',
    },
    {
      duration: params.duration,
      easing: params.easing,
      complete: params.complete,
      step: function (now) {
        $obj.css('transform', 'translateX(' + (1 - now) * 110 + '%)');
      },
    },
  );
};

if (!$.events) $.events = { ui: [], auth: [] };

$.onInit = $.fn.onInit = function (handler) {
  $.events.ui.push([this, handler]);
  return this;
};

$.registerUI = (name, handlers) => {
  console.debug(`UI: Registering '${name}'...`);
  UI[name] = handlers;
};

$.initUI = async () => {
  console.debug('UI: Init...');
  $('body').initUI();
};

$.fn.initUI = function (...names) {
  if (names.length) {
    for (const name of names) {
      const ui = UI[name];
      if (ui && ui.init) ui.init.call(this);
    }

    return this;
  }

  for (const ui of Object.values(UI)) {
    if (ui && ui.init) ui.init.call(this);
  }

  return this;
};

$.fn.hideUI = function (...names) {
  if (names.length) {
    for (const name of names) {
      const ui = UI[name];
      if (ui && ui.hide) ui.hide.call(this);
    }

    return this;
  }

  for (const ui of Object.values(UI)) {
    if (ui && ui.hide) ui.hide.call(this);
  }

  return this;
};

$.waitFor = async (handler, timeout = 100) => {
  await new Promise(resolve => {
    (function wait() {
      if (handler()) resolve();
      setTimeout(wait, timeout);
    })();
  });
};

// $.onInit(() => [import('lib/tooltip'), import('lib/popover')]);

// REMOVE LATER: debug query params for selectively skipping init imports.
const debug_search_params = new URLSearchParams(W.location.search);
const debug_skip_init = debug_search_params.get('skip_init') === '1';
const debug_skip_tooltip = debug_search_params.get('skip_tooltip') === '1';
const debug_skip_popover = debug_search_params.get('skip_popover') === '1';

// REMOVE LATER: allow skipping the onInit import step entirely or selectively.
if (!debug_skip_init) {
  $.onInit(() => {
    const init_promises = [];

    if (!debug_skip_tooltip) init_promises.push(import('lib/tooltip'));
    if (!debug_skip_popover) init_promises.push(import('lib/popover'));

    return init_promises;
  });
}

document.onreadystatechange = () => {
  if (document.readyState === 'interactive') {
    (async () => {
      await $.initAuth();
      await Promise.all($.events.ui.map(([ctx, handler]) => handler.call(ctx)));
      waitForAuth = false;
    })();
  }

  if (document.readyState === 'complete') {
    (async () => {
      await $.waitFor(() => !waitForAuth);
      await $.initUI();
      await Promise.all($.events.auth.map(([ctx, handler]) => handler.call(ctx, W.AUTH)));
    })();
  }
};

export default $;
